export default __webpack_public_path__ + "static/2.5.1/media/topUpAccount.e4f6820b.svg";